import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ExtratoBancarioItemStruct } from '../../../../../shared/services/structs/financas/extrato-bancario-item.struct';
import { RegistroAssociavelItemStruct } from '../../../../../shared/services/structs/financas/registro-associavel-item.struct';
import { NaturezaMovimentacaoEnum } from '../../../../../shared/enums/financas/natureza-movimentacao.enum';
import { UtilService } from '../../../../../shared/services/util.service';
import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';
import { AssociarLancamentoComponent } from './associar-lancamento/associar-lancamento.component';
import { RevisarValoresComponent } from './revisar-valores/revisar-valores.component';

export interface BuscarLancamentosDialogData {
  idContaFinanceira: number;
  extrato: ExtratoBancarioItemStruct;
}

@Component({
  selector: 'app-buscar-lancamentos-dialog',
  standalone: true,
  imports: [
    CommonModule,
    AbntPipe,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    AssociarLancamentoComponent,
    RevisarValoresComponent,
  ],
  templateUrl: './buscar-lancamentos-dialog.component.html',
  styleUrls: ['./buscar-lancamentos-dialog.component.css'],
})
export class BuscarLancamentosDialogComponent {
  tela: 'associar' | 'revisar' = 'associar';
  itensSelecionadosParaRevisar: RegistroAssociavelItemStruct[] = [];
  naturezaEnum = NaturezaMovimentacaoEnum;
  readonly Math = Math;

  @ViewChild('associarRef') associarRef?: AssociarLancamentoComponent;
  @ViewChild('revisarRef') revisarRef?: RevisarValoresComponent;

  constructor(
    public dialogRef: MatDialogRef<BuscarLancamentosDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BuscarLancamentosDialogData,
  ) { }

  get totalBanco(): number {
    return UtilService.arredondarAbnt(Math.abs(this.data.extrato.valor), 2);
  }

  abrirRevisar(itens: RegistroAssociavelItemStruct[]): void {
    this.itensSelecionadosParaRevisar = itens;
    this.tela = 'revisar';
  }

  voltarParaAssociar(): void {
    this.tela = 'associar';
  }
}
